import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import AiChart from "./components/aiChart.component.js";

const LangflowChatPage = () => {
  // State for chat messages and user input
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Handle sending a message to the Langflow API
  const sendMessage = async (message) => {
    setIsLoading(true);

    const company_id = "som1"; // Change it based on company_id after all database is ready
    const combined_message = `<company>${company_id}</company><question>${message}</question>`;
    console.log("Combined_msg : ", combined_message);
    // Add user message to chat
    const userMessage = { role: "user", content: message };
    setMessages((prev) => [...prev, userMessage]);

    // Prepare the payload
    const payload = {
      input_value: combined_message,
      output_type: "chat",
      input_type: "chat",
      session_id: "user_1", // Optional session tracking
      // output_component: "CustomComponent-PsUi5",
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "sk-bhj5Yey7SWVpyQMZ-nZckkdBj1T20ORDFrAywK_ha6k",
      },
      body: JSON.stringify(payload),
    };

    try {
      const response = await fetch(
        // "http://localhost:7860/api/v1/run/d8a78821-4619-4e2e-bc94-55da4ed945e3", //local
        // "https://ai.dev.smartkood.com/api/v1/run/cb7ac04d-1232-42d4-adad-6a171ee76102", //dev -> to langflow v1
        "https://ai.dev.smartkood.com/api/v1/run/d3b54d81-6052-4d66-8e8d-43308aa644da", //dev -> to langflow v2
        options
      );

      if (!response.ok) {
        throw new Error(
          `HTTP error! Status: ${response.status}, Status Text: ${response.statusText}`
        );
      }

      const data = await response.json();

      const aiResponse =
        data?.outputs?.[0]?.outputs?.[0]?.results?.message?.text ||
        "No response received";
      console.log("AI Response:", aiResponse);
      const answerMatch = aiResponse.match(/<answer>([\s\S]*?)<\/answer>/);
      const chart_type = aiResponse.match(
        /<chart_type>([\s\S]*?)<\/chart_type>/
      );
      const chart_data = aiResponse.match(/<chart>([\s\S]*?)<\/chart>/);

      let extractedAnswer = "No answer received";

      // Extract answer if available
      if (answerMatch && answerMatch[1]) {
        extractedAnswer = answerMatch[1].trim();
        extractedAnswer = extractedAnswer
          .replace(/^Answer:\n/, "")
          .replace(/\n$/, "");
      }

      let aiMessage = {};

      // Check if chart_type or chart_data contains "No Matches Found"
      if (
        chart_type[1].trim().toLowerCase() === "no matches found" ||
        chart_data[1].trim().toLowerCase() === "no matches found"
      ) {
        aiMessage = { role: "assistant", content: extractedAnswer };
      } else if (
        chart_type[1] &&
        chart_type[1].trim().toLowerCase() !== "no matches found"
      ) {
        try {
          const validJsonString = chart_data[1]
            .replace(/([a-zA-Z0-9_]+):/g, '"$1":')
            .replace(/'([^']+)'/g, '"$1"')
            .replace(/,\s*}/g, "}")
            .replace(/,\s*\]/g, "]");

          const dataRegex = /const data = ({[\s\S]*?});/;
          const optionsRegex = /const options = ({[\s\S]*?});/;

          const chartDataMatch = validJsonString.match(dataRegex);
          const chartOptionsMatch = validJsonString.match(optionsRegex);

          // Parse the extracted JSON-like string
          const chartData = chartDataMatch[1]
            ? JSON.parse(chartDataMatch[1])
            : null;
          const chartOptions = chartOptionsMatch[1]
            ? JSON.parse(chartOptionsMatch[1])
            : null;

          aiMessage = {
            role: "assistant",
            content: extractedAnswer,
            chart_type: chart_type[1]
              .toLowerCase()
              .replace(/\s+/g, "")
              .replace(/\n+/g, ""),
            chart_data: chartData,
            chart_options: chartOptions,
          };
        } catch (error) {
          console.error("Error parsing data JSON:", error.message);
        }
      } else {
        aiMessage = { role: "assistant", content: extractedAnswer };
      }

      setMessages((prev) => [...prev, aiMessage]);
    } catch (error) {
      console.error("Error fetching Langflow API:", error.message);
      const errorMessage = {
        role: "assistant",
        content: "Sorry, an error occurred. Please try again.",
      };
      setMessages((prev) => [...prev, errorMessage]);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputValue.trim()) return;
    sendMessage(inputValue);
    setInputValue("");
  };

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div
      style={{
        height: "72vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Chat Header */}
      <div
        style={{
          padding: "10px",
          backgroundColor: "#007bff",
          color: "white",
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        Vector Store RAG Chat
      </div>

      {/* Chat Messages */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {messages.map((msg, index) => (
          <div
            key={index}
            style={{
              alignSelf: msg.role === "user" ? "flex-end" : "flex-start",
              maxWidth: "80%",
              padding: "10px",
              borderRadius: "8px",
              backgroundColor: msg.role === "user" ? "#007bff" : "#e0e0e0",
              color: msg.role === "user" ? "white" : "black",
              wordBreak: "break-word",
            }}
          >
            {msg.role === "assistant" ? (
              <>
                {msg.chart_type && msg.chart_data ? (
                  <>
                    <div style={{ minWidth: "750px" }}>
                      <AiChart
                        chartType={msg.chart_type}
                        data={msg.chart_data}
                        options={msg.chart_options}
                      />
                    </div>
                    <br />
                  </>
                ) : null}
                <ReactMarkdown>{msg.content}</ReactMarkdown>
              </>
            ) : (
              msg.content
            )}
          </div>
        ))}
        {isLoading && (
          <div
            style={{
              alignSelf: "flex-start",
              padding: "10px",
              color: "#666",
            }}
          >
            Typing...
          </div>
        )}
      </div>

      {/* Chat Input */}
      <form
        onSubmit={handleSubmit}
        style={{
          padding: "10px",
          backgroundColor: "white",
          borderTop: "1px solid #ddd",
          display: "flex",
          gap: "10px",
        }}
      >
        <textarea
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Type your message..."
          style={{
            flex: 1,
            padding: "10px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            resize: "none",
            height: "40px",
            fontSize: "14px",
          }}
        />
        <button
          type="submit"
          disabled={isLoading || !inputValue.trim()}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: isLoading || !inputValue.trim() ? "not-allowed" : "pointer",
            fontSize: "14px",
          }}
        >
          Send
        </button>
      </form>
    </div>
  );
};

export default LangflowChatPage;
